import React, { useEffect, useState } from 'react';
import { MapPin, X } from 'lucide-react';
const notifications = [{
  name: 'Julián M.',
  city: 'Buenos Aires'
}, {
  name: 'Martín P.',
  city: 'Córdoba'
}, {
  name: 'Carla R.',
  city: 'Rosario'
}, {
  name: 'Santiago F.',
  city: 'Mar del Plata'
}, {
  name: 'Diego I.',
  city: 'Mendoza'
}, {
  name: 'Lucas G.',
  city: 'La Plata'
}, {
  name: 'Facundo T.',
  city: 'Tucumán'
}];
export function PopUpNotification() {
  const [currentNotif, setCurrentNotif] = useState(notifications[0]);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const showNotification = () => {
      const randomNotif = notifications[Math.floor(Math.random() * notifications.length)];
      setCurrentNotif(randomNotif);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    // Initial delay
    const initialTimer = setTimeout(showNotification, 10000);
    // Recurring interval
    const intervalTimer = setInterval(showNotification, 25000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(intervalTimer);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-fade-in-up" data-id="element-219">
      <div className="bg-white text-gray-900 rounded-lg shadow-2xl p-4 pr-10 flex items-center gap-4 relative max-w-sm border-l-4 border-[#C6F432]" data-id="element-220">
        <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" data-id="element-221">
          <X size={16} data-id="element-222" />
        </button>
        <div className="bg-[#0A1628] p-2 rounded-full text-[#C6F432]" data-id="element-223">
          <MapPin size={20} data-id="element-224" />
        </div>
        <div data-id="element-225">
          <p className="text-sm font-bold" data-id="element-226">
            {currentNotif.name} de {currentNotif.city}
          </p>
          <p className="text-xs text-gray-600" data-id="element-227">
            Compró Megapack Padel Resuelto™
          </p>
          <p className="text-xs text-gray-400 mt-1" data-id="element-228">Hace unos minutos</p>
        </div>
      </div>
    </div>;
}